<template>
  <i class="tm-grid">
    <tm-row v-for="row in rows" :key="row.rowId" :row="row" />
  </i>
</template>

<script>
import tmRow from './tmRow.vue';
import { mapState } from 'vuex';

export default {
  name: 'tm-grid',
  components: {
    tmRow,
  },

  computed: {
    ...mapState('timemachine', {
      rows: (state) => state.timeLayer.rows,
    }),
  },
};
</script>

<style lang="scss">
.tm-timemachine > .tm-grid {
  padding: var(--tm-pxAxisTopPadding) var(--tm-pxAxisSidePadding) 45px
    var(--tm-pxAxisSidePadding);
  margin: 0;
  min-height: var(--tm-pxRowHeight);
  display: block;
}
</style>
